<template>
  <el-config-provider :locale="elementLocale">
    <router-view />
  </el-config-provider>
</template>

<script setup>
import { onErrorCaptured, computed } from 'vue'
import { ElMessage, ElConfigProvider } from 'element-plus'
import { useI18n } from 'vue-i18n'
import en from 'element-plus/es/locale/lang/en'
import zhCn from 'element-plus/es/locale/lang/zh-cn'
import ug from 'element-plus/es/locale/lang/ug-cn'

const { locale } = useI18n()

const elementLocale = computed(() => {
  switch (locale.value) {
    case 'en':
      return en
    case 'ug':
      return ug
    case 'zh':
    default:
      return zhCn
  }
})

// Global error handler for component errors - prevents one broken component from crashing the app
onErrorCaptured((err, instance, info) => {
  console.error('[App Error Captured]', err)
  console.error('[Component]', instance?.$options?.name || 'Unknown')
  console.error('[Info]', info)
  
  // Show user-friendly error message
  ElMessage.error({
    message: 'An error occurred. Please try refreshing the page.',
    duration: 5000,
    showClose: true
  })
  
  // Don't propagate the error further to prevent app crash
  return false
})
</script>

<style lang="scss">
// Prevent body scroll, only allow content area to scroll
html, body {
  margin: 0;
  padding: 0;
  height: 100%;
  overflow: hidden;
  /* Fix iOS scroll bounce issue */
  -webkit-overflow-scrolling: touch;
}

#app {
  height: 100vh;
  height: 100dvh; /* Dynamic viewport height for mobile */
  overflow: hidden;
}
</style>
